/**
 * Constantes y configuraciones para el módulo Auth
 */

/**
 * Límites de validación para campos de autenticación
 */
export const LIMITES_VALIDACION = {
    USUARIO_MIN: 3,
    USUARIO_MAX: 50,
    PASSWORD_MIN: 6,
    PASSWORD_MAX: 100,
    EMAIL_MAX: 100,
} as const;

/**
 * Mensajes de error estandarizados
 */
export const MENSAJES_ERROR = {
    // Validación de campos
    USUARIO_REQUERIDO: 'Por favor ingresa tu usuario',
    USUARIO_MIN_LENGTH: `El usuario debe tener al menos ${LIMITES_VALIDACION.USUARIO_MIN} caracteres`,
    PASSWORD_REQUERIDO: 'Por favor ingresa tu contraseña',
    PASSWORD_MIN_LENGTH: `La contraseña debe tener al menos ${LIMITES_VALIDACION.PASSWORD_MIN} caracteres`,
    PASSWORD_NO_COINCIDEN: 'Las contraseñas no coinciden',
    EMAIL_INVALIDO: 'Por favor ingresa un email válido',
    TOKEN_INVALIDO: 'El token de recuperación es inválido o ha expirado',

    // Errores de autenticación
    ERROR_LOGIN: 'Error al iniciar sesión',
    ERROR_LOGOUT: 'Error al cerrar sesión',
    ERROR_RECUPERACION: 'Error al solicitar recuperación de contraseña',
    ERROR_RESTABLECER: 'Error al restablecer contraseña',
    ERROR_ACTIVAR: 'Error al activar cuenta',
    ERROR_PERFIL: 'Error al obtener perfil',

    // Mensajes específicos
    CREDENCIALES_INVALIDAS: 'Usuario o contraseña incorrectos',
    SESION_EXPIRADA: 'Tu sesión ha expirado',
    CUENTA_INACTIVA: 'Tu cuenta está inactiva',

    // Bloqueo de aplicación
    CONTRASENA_REQUERIDA: 'Por favor ingresa tu contraseña',
    CONTRASENA_INCORRECTA: 'Contraseña incorrecta',
    ERROR_VALIDAR_CONTRASENA: 'Error al validar contraseña',
} as const;

/**
 * Mensajes de éxito
 */
export const MENSAJES_EXITO = {
    LOGIN_EXITOSO: 'Sesión iniciada exitosamente',
    LOGOUT_EXITOSO: 'Sesión cerrada exitosamente',
    RECUPERACION_ENVIADA: 'Se ha enviado un correo con instrucciones para recuperar tu contraseña',
    PASSWORD_CAMBIADO: 'Contraseña cambiada exitosamente',
    CUENTA_ACTIVADA: 'Cuenta activada exitosamente',
} as const;

/**
 * Textos de la interfaz de usuario
 */
export const TEXTOS_UI = {
    // Login
    LOGIN_TITULO: 'Iniciar Sesión',
    LOGIN_SUBTITULO: 'Sistema ERP - Zafiro',
    LOGIN_USUARIO_LABEL: 'Usuario:',
    LOGIN_PASSWORD_LABEL: 'Contraseña:',
    LOGIN_USUARIO_PLACEHOLDER: 'Ingresa tu nombre de usuario',
    LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
    LOGIN_BOTON: 'Iniciar Sesión',
    LOGIN_CONTINUAR_BOTON: 'Continuar',
    LOGIN_CARGANDO: 'Iniciando sesión...',
    LOGIN_OLVIDO_PASSWORD: '¿Olvidó su contraseña?',
    LOGIN_REGRESAR_BOTON: 'Regresar',

    // Recuperación de contraseña
    RECUPERACION_TITULO: 'Recuperar Contraseña',
    RECUPERACION_SUBTITULO: 'Ingresa tu email o usuario',
    RECUPERACION_LABEL: 'Email o Usuario:',
    RECUPERACION_PLACEHOLDER: 'ejemplo@correo.com',
    RECUPERACION_BOTON: 'Enviar instrucciones',
    RECUPERACION_CARGANDO: 'Enviando...',
    RECUPERACION_VOLVER_LOGIN: 'Volver al inicio de sesión',

    // Restablecer contraseña
    RESTABLECER_TITULO: 'Restablecer Contraseña',
    RESTABLECER_NUEVA_PASSWORD_LABEL: 'Nueva Contraseña:',
    RESTABLECER_CONFIRMAR_PASSWORD_LABEL: 'Confirmar Contraseña:',
    RESTABLECER_NUEVA_PASSWORD_PLACEHOLDER: 'Ingresa tu nueva contraseña',
    RESTABLECER_CONFIRMAR_PASSWORD_PLACEHOLDER: 'Confirma tu nueva contraseña',
    RESTABLECER_BOTON: 'Cambiar Contraseña',
    RESTABLECER_CARGANDO: 'Cambiando contraseña...',

    // Activación de cuenta
    ACTIVACION_TITULO: 'Activar Cuenta',
    ACTIVACION_EXITOSO: '¡Tu cuenta ha sido activada exitosamente!',
    ACTIVACION_ERROR: 'No se pudo activar tu cuenta',
    ACTIVACION_PROCESANDO: 'Activando cuenta...',
    ACTIVACION_IR_LOGIN: 'Ir al inicio de sesión',

    // Usuarios de prueba
    USUARIOS_PRUEBA_MOSTRAR: 'Mostrar usuarios de prueba',
    USUARIOS_PRUEBA_OCULTAR: 'Ocultar usuarios de prueba',

    // Tema
    TEMA_CAMBIAR_CLARO: 'Cambiar a tema claro',
    TEMA_CAMBIAR_OSCURO: 'Cambiar a tema oscuro',

    // Acciones
    MOSTRAR_PASSWORD: 'Mostrar contraseña',
    OCULTAR_PASSWORD: 'Ocultar contraseña',
    CARGANDO: 'Cargando...',

    // Bloqueo de aplicación
    APP_BLOQUEADA: 'La aplicación está bloqueada',
    DESBLOQUEAR: 'Desbloquear',
    CERRAR_SESION: 'Cerrar Sesión',
} as const;
